class NavSearch {
  init(){
      // Initial search state elements
      var searchOpen = document.getElementById('search-open');
      var searchFocus = document.getElementById('search-focus');
      var searchResults = document.getElementById('search-results');
      var globalSearchForm = document.getElementById('global-search-form');
      var globalSearchInput = document.getElementById('globalsearch');
      var searchInputContainer = document.getElementById('nav-search-input-container');
      var clearButton = document.getElementById('global-search-clear-button');

      if (
        !searchOpen
        || !searchFocus
        || !searchResults
        || !globalSearchForm
        || !globalSearchInput
        || !searchInputContainer
        || !clearButton
      ) {
        return;
      }

      var globalSearchInputContainer = globalSearchForm.querySelector('.global-search-input-container');
      var globalSearchTitleContainer = searchInputContainer.querySelector('.global-search-title-container');

      if (!globalSearchInputContainer || !globalSearchTitleContainer) {
        return;
      }

      // Grab your “View All Results” divs and buttons
      var viewAllResultsMobile = document.getElementById('view-all-results-mobile');
      var viewAllResultsDesktop = document.getElementById('view-all-results-desktop');
      var viewAllResultsBtnMobile = document.getElementById('viewAllResultsBtnMobile');
      var viewAllResultsBtnDesktop = document.getElementById('viewAllResultsBtnDesktop');

      // Initial state
      searchOpen.style.display = 'block';
      searchFocus.style.display = 'none';
      searchResults.style.display = 'none';

      // Hide the "View All Results" by default (in case you’re not using hidden classes)
      if (viewAllResultsMobile) viewAllResultsMobile.style.display = 'none';
      if (viewAllResultsDesktop) viewAllResultsDesktop.style.display = 'none';

      var searchResultsHaveBeenResized = false;
      var searchFocusHasBeenResized = false;

      function showResults(){
        searchOpen.style.display = 'none';
        searchFocus.style.display = 'none';
        searchResults.style.display = 'block';
        clearButton.style.visibility = 'visible';
        globalSearchInputContainer.classList.add('has-text');
        globalSearchTitleContainer.classList.add('search-filled');

        if(!searchResultsHaveBeenResized){
          var domRect = searchInputContainer.getBoundingClientRect();
          var spaceBelow = window.innerHeight - domRect.bottom + 50;
          searchResults.style.height = spaceBelow + "px";
        }
      }

      function hideResults(){
        searchOpen.style.display = 'none';
        searchFocus.style.display = 'block';
        searchResults.style.display = 'none';
        searchResults.style.height = 'unset';
        clearButton.style.visibility = 'hidden';
        globalSearchInputContainer.classList.remove('has-text');
        globalSearchTitleContainer.classList.remove('search-filled');
        if(!searchFocusHasBeenResized) {
          var domRect = searchInputContainer.getBoundingClientRect();
          var spaceBelow = window.innerHeight - domRect.bottom + 50;
          searchFocus.style.height = spaceBelow + "px";
        }
      }

      globalSearchInput.addEventListener('focus', event => {
        if(!event.target.value.length) {
          globalSearchInputContainer.classList.add('focused-empty');
        }
      });

      globalSearchInput.addEventListener('focusout', event => {
        if(!event.target.value.length) {
          globalSearchInputContainer.classList.remove('focused-empty');
        }
      });

      let isFirstOpen = true;
      let isFirstClick = true;

      globalSearchForm.addEventListener('click', event => {
        if(isFirstClick) {
          hideResults();
        }
        else {
          isFirstClick = false;
        }
      });

      // Handle form focus
      globalSearchForm.addEventListener('focusin', function() {
        if(!isFirstOpen){
          if (globalSearchInput.value.trim() === '') {
            hideResults();
          } else {
            // If the input already has text:
            showResults();
          }
        }
        else {
          isFirstOpen = false;
        }
      });

      // Fix the reference here to globalSearchInput instead of searchInput
      globalSearchInput.addEventListener('keyup', function() {
        if (globalSearchInput.value.trim() === '') {
          hideResults();
        }
        isFirstClick = false;
      });

      // Click handlers for "View All Results"
      function onViewAllResultsClick() {
        const query = globalSearchInput.value.trim();
        if (query) {
          // Redirect to /search?q=YOUR_QUERY
          window.location.href = '/'+window.algoliaConfig.searchSlug+'?q=' + encodeURIComponent(query);
        }
      }

      if (viewAllResultsBtnMobile) {
        viewAllResultsBtnMobile.addEventListener('click', onViewAllResultsClick);
      }
      if (viewAllResultsBtnDesktop) {
        viewAllResultsBtnDesktop.addEventListener('click', onViewAllResultsClick);
      }

      // This function should be called when Algolia results come back
      function onAlgoliaResultsReturned() {
        showResults();
      }

      clearButton.addEventListener('click', function(){
        searchInput.value = '';
        globalSearchInputContainer.classList.remove('focused-empty');
        hideResults();
      })

      // Algolia Credentials
      const {
          applicationId: ALGOLIA_APPLICATION_ID,
          searchKey:       ALGOLIA_SEARCH_API_KEY,
          indexName:       ALGOLIA_INDEX_NAME,
          siteHandle,      // the current Craft site handle
          cacheEnabled,
          cacheWorkerHost
      } = window.algoliaConfig;

      let searchClient;
      try {
          // Use the helper function if available, otherwise fall back to direct initialization
          // The helper routes through cache proxy when enabled via CMS toggle
          if (typeof window.createAlgoliaClient === 'function') {
              searchClient = window.createAlgoliaClient();
          } else {
              const { liteClient: algoliasearch } = window['algoliasearch/lite'];
              const clientOptions = cacheEnabled && cacheWorkerHost
                  ? { hosts: [{ url: cacheWorkerHost, accept: 'read', protocol: 'https' }] }
                  : {};
              searchClient = algoliasearch(ALGOLIA_APPLICATION_ID, ALGOLIA_SEARCH_API_KEY, clientOptions);
          }
      } catch (e) {
          console.error('Algolia init error', e);
          return;
      }

      // Select DOM Elements
      const searchInput = document.getElementById('globalsearch');
      const productsContainer = document.getElementById('products-hits');
      const productsContainerMobile = document.getElementById('products-hits-mobile');
      const inspirationContainer = document.getElementById('inspiration-hits');
      const loadingIndicator = document.getElementById('loading-indicator'); // Optional

      // Validate DOM Elements
      if (!searchInput || !productsContainer || !productsContainerMobile || !inspirationContainer) {
        console.error('One or more required DOM elements are missing.');
        return;
      }

      /**
       * Debounce Function to Limit Search Frequency
       * @param {Function} func - The function to debounce
       * @param {number} wait - The debounce delay in milliseconds
       * @returns {Function} - The debounced function
       */
      const debounce = (func, wait) => {
        let timeout;
        return function(...args) {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), wait);
        };
      };

      /**
       * Function to Perform Search and Render Results
       * @param {string} query - The search query entered by the user
       */
      const performSearch = async (query) => {
        try {
          // Show loading indicator if available
          if (loadingIndicator) {
            loadingIndicator.style.display = 'block';
          }

          // Perform the search query.
          // v5 lite client exposes the multi-query `search([requests])` method (no `searchSingleIndex`,
          // which lives only on the full client). It POSTs to /1/indexes/*/queries and returns { results: [...] }.
            const { results } = await searchClient.search([
                {
                    indexName: ALGOLIA_INDEX_NAME,
                    params: {
                        query,
                        hitsPerPage: 200,
                        facetFilters: [`siteHandle:${siteHandle}`]
                    }
                }
            ]);

          const hits = results[0].hits;

          // Initialize arrays for each type
          const products = [];
          const recipes = [];
          const blogs = [];

          // Categorize hits based on 'type'
          for (const hit of hits) {
            if (hit.type === 'products' && products.length < 6) {
              products.push(hit);
            } else if (hit.type === 'recipes') {
              recipes.push(hit);
            } else if (hit.type === 'blog') {
              blogs.push(hit);
            }
          }

          // Prepare Inspiration Results
          const inspiration = [];

          if (recipes.length > 0 && blogs.length > 0) {
            // Both recipes and blogs have results
            inspiration.push(recipes[0]);
            inspiration.push(blogs[0]);
          } else if (recipes.length > 0) {
            // Only recipes have results
            const count = Math.min(2, recipes.length);
            for (let i = 0; i < count; i++) {
              inspiration.push(recipes[i]);
            }
          } else if (blogs.length > 0) {
            // Only blogs have results
            const count = Math.min(2, blogs.length);
            for (let i = 0; i < count; i++) {
              inspiration.push(blogs[i]);
            }
          }

          // Render the categorized results
          renderResults(products, inspiration);

          // Once results are rendered, show the search-results section
          onAlgoliaResultsReturned();

        } catch (error) {
          console.error('Algolia Search Error:', error);
          // Optionally, display an error message to the user
          renderError('An error occurred while performing the search. Please try again.');
        } finally {
          // Hide loading indicator if available
          if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
          }
        }
      };

      const productTemplate = document.getElementById('search-result-product');
      const productMobileTemplate = document.getElementById('search-result-product-mobile');
      const inspirationTemplate = document.getElementById('search-result-inspiration');

      /**
       * Function to Render Results into the DOM
       * @param {Array} products - Array of product hits
       * @param {Array} inspiration - Array of recipe and blog hits
       */
      const renderResults = (products, inspiration) => {
        // Clear previous results
        productsContainer.innerHTML = '';
        productsContainerMobile.innerHTML = '';
        inspirationContainer.innerHTML = '';

        const searchResultCarouselMobile = window.emblaApis['search-product-carousel-mobile']

        // Render Products
        if (products.length > 0) {
          products.forEach(product => {
            const newItem = productTemplate.content.cloneNode(true);
            const newItemTitle = newItem.querySelector('[data-title]');
            const newItemImage = newItem.querySelector('[data-image]');
            const newItemLink = newItem.querySelector('[data-link]');

            newItemTitle.innerHTML = sanitizeHTML(product.title);
            newItemImage.src = product.Featured_Image;
            newItemImage.alt = product.title;

              newItemLink.href = `/${window.algoliaConfig.productSlug}/${product.slug}/`;
              productsContainer.appendChild(newItem);

            // Append to mobile carousel
            if (searchResultCarouselMobile) {
              const newSlide = productMobileTemplate.content.cloneNode(true);
              const newSlideTitle = newSlide.querySelector('[data-title]');
              const newSlideImage = newSlide.querySelector('[data-image]');
              const newSlideLink = newSlide.querySelector('[data-link]');

              newSlideTitle.innerHTML = sanitizeHTML(product.title);
              newSlideImage.src = product.Featured_Image;
              newSlideImage.alt = product.title;
              newSlideLink.href = `/${window.algoliaConfig.productSlug}/${product.slug}/`;

              productsContainerMobile.appendChild(newSlide);
            }
          });

          // Reinit carousel
          if (searchResultCarouselMobile) {
            searchResultCarouselMobile.reInit();
          }

        } else {
          productsContainer.innerHTML = '<p>'+window.noProductsFoundMessage+'</p>';
        }

        // Render Inspiration (Recipes and Blogs)
        if (inspiration.length > 0) {
          inspiration.forEach(item => {
            const newItem = inspirationTemplate.content.cloneNode(true);
            const newItemTitle = newItem.querySelector('[data-title]');
            const newItemImage = newItem.querySelector('[data-image]');
            const newItemTags = newItem.querySelector('[data-tags]');
            const newItemLink = newItem.querySelector('[data-link]');

            let tags = '';
            let link = '';
            switch (item.type) {
              case 'blog':
                tags = 'Article';
                if (item.Blog_Tags) {
                  tags += '&ensp;|&ensp;' + item.Blog_Tags[0];
                }
                link = `/articles/${item.slug}`;
                break;
              case 'recipes':
                tags = 'Recipe';
                if (item.Recipe_Categories) {
                  tags += '&ensp;|&ensp;' + item.Recipe_Categories[0];
                }
                link = `/recipes/how-to-make/${item.slug}`;
                break;
            }

            newItemTitle.innerHTML = sanitizeHTML(item.title);
            newItemImage.src = item.Featured_Image;
            newItemImage.alt = item.title;
            newItemTags.innerHTML = tags;
            newItemLink.href = link;

            inspirationContainer.appendChild(newItem);
          });
        } else {
          inspirationContainer.innerHTML = '<p>No inspiration items found.</p>';
        }

        // ---- SHOW/HIDE THE “VIEW ALL RESULTS” BUTTON ----
        // Combine the sets. If any results are present, show buttons. Otherwise hide them.
        const hasAnyResults = (products.length > 0 || inspiration.length > 0);

        if (hasAnyResults) {
          // If using Tailwind “hidden” classes, remove them:
          if (viewAllResultsMobile) {
            viewAllResultsMobile.style.display = 'block';
            // OR .classList.remove('hidden')
          }
          if (viewAllResultsDesktop) {
            viewAllResultsDesktop.style.display = 'block';
            // OR .classList.remove('hidden')
          }
        } else {
          if (viewAllResultsMobile) {
            viewAllResultsMobile.style.display = 'none';
            // OR .classList.add('hidden')
          }
          if (viewAllResultsDesktop) {
            viewAllResultsDesktop.style.display = 'none';
            // OR .classList.add('hidden')
          }
        }
      };

      /**
       * Function to Render Error Messages
       * @param {string} message - The error message to display
       */
      const renderError = (message) => {
        // Clear previous results
        productsContainer.innerHTML = '';
        inspirationContainer.innerHTML = '';

        // Display error message in each section
        productsContainer.innerHTML = `<p>${sanitizeHTML(message)}</p>`;
        inspirationContainer.innerHTML = `<p>${sanitizeHTML(message)}</p>`;
      };

      /**
       * Utility Function to Sanitize HTML Content
       * Prevents XSS attacks by escaping HTML entities
       * @param {string} str - The string to sanitize
       * @returns {string} - Sanitized string
       */
      const sanitizeHTML = (str) => {
        const temp = document.createElement('div');
        temp.textContent = str;
        return temp.innerHTML;
      };

      /**
       * Debounced Function to Handle Input Events
       */
      const handleInput = debounce((event) => {
        const query = event.target.value.trim();

        if (query === '') {
          // Clear results if input is empty
          productsContainer.innerHTML = '';
          inspirationContainer.innerHTML = '';
          // Also hide the "View All" button(s)
          if (viewAllResultsMobile) viewAllResultsMobile.style.display = 'none';
          if (viewAllResultsDesktop) viewAllResultsDesktop.style.display = 'none';
          return;
        }

        // Perform the search
        performSearch(query);
      }, 300); // 300ms debounce delay

      /**
       * Event Listener for Input Events on Search Box
       */
      searchInput.addEventListener('input', handleInput);

      // Select all popular search buttons
      const popularSearchButtons = document.querySelectorAll('.popularSearch');

      // Add click event listeners to each button
      popularSearchButtons.forEach(button => {
        button.addEventListener('click', function() {
          // Get the search term from the data attribute
          const searchTerm = this.getAttribute('data-popularsearchtext');

          searchInput.focus();

          // Set the input field with this search term
          searchInput.value = searchTerm;

          // Initiate the Algolia search
          performSearch(searchTerm);
        });
      });

  }
}

export {NavSearch};
